import v5_Model from '@/models/v5/model';
import Api from '@/lib/api/api';

var LoginKey = v5_Model.extend({
    initialize: function () {
        this.type = LoginKey.type;
    },
    /**
     * Update adds the authorization before saving
     * @param pass string current pw
     * @param attributes Object 
     * @param options please use an success / error callback
     */
    update: function(pass, attributes, options) {
        var headers = Api.getHeaderDefaults();
        headers['X-Electricimp-Password'] = pass;

        var data = {
            data: {
                type: this.type,
                id: this.id,
                attributes: attributes
            }
        };

        return this.save(data, {
            patch: true,
            headers: headers,
            wait: true,
            success: options.success || function(res) { return res; },
            error: options.error || function (err) { return err; }
        });
    }
});

LoginKey.type = 'login_key';
export default LoginKey;
